import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { termOptions } from '../../utils/helper';
import Input from '../../components/Input/Input';
import Select from '../../components/Select/Select';
import AssignmentGrid from '../../components/AssignmentGrid/AssignmentGrid';

const AssessmentListForm = ({ handleSubmit, handleChange, handleSwitchChange, handleInputChange,
  state, programData }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-4 mb-3">
          <Input
            label={"Name"}
            type="text"
            name="name"
            id="name"
            onChangeHandler={handleChange}
            placeholder="Enter Name"
            value={state.name}
            required={true}
          />
        </div>
        <div className="col-md-4 mb-3">
          <Select
            label={"Term"}
            name="term"
            value={state.term}
            onChangeHandler={handleChange}
            options={termOptions}
            required={true}
            placeholder="Select Term"
          />
        </div>
        <div className="col-md-4 mb-3">
          <Input
            label={"Position"}
            name="position"
            value={state.position}
            onChangeHandler={handleChange}
            placeholder="Enter Position"
            required={true}
          />
        </div>

        <AssignmentGrid
          label="Available for classes"
          items={programData}
          selectedIds={state.program_ids || []}
          onToggle={handleInputChange}
          onSelectAll={handleSwitchChange}
          switchName="program_ids"
        />
      </div>
      <div className="row justify-content-end mt-3">
        <div className="col-md-1">
          <Button variant="success"
            disabled={state.loading}
            type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default AssessmentListForm;
